'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _transform2 = require('lodash/transform');
var _transform3 = _interopRequireDefault(_transform2);
var _split2 = require('lodash/split');
var _split3 = _interopRequireDefault(_split2);
var _map2 = require('lodash/map');
var _map3 = _interopRequireDefault(_map2);
var _isUndefined2 = require('lodash/isUndefined');
var _isUndefined3 = _interopRequireDefault(_isUndefined2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
var _has2 = require('lodash/has');
var _has3 = _interopRequireDefault(_has2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');
var _dimensionUtils = require('../dimension-utils');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var parseByAreas = function parseByAreas(observations, refAreaDimension) {
  if ((0, _isUndefined3.default)(refAreaDimension)) {
    return null;
  }
  var refAreaDimIndex = (0, _get3.default)(refAreaDimension, 'index');
  var refAreaValues = refAreaDimension.values;
  return (0, _transform3.default)(observations, function (acc, value, key) {
    var splitedKey = (0, _split3.default)(key, ':');
    var areaValueIndex = (0, _get3.default)(splitedKey, '[' + refAreaDimIndex + ']', null);
    var areaValue = (0, _get3.default)(refAreaValues, '[' + areaValueIndex + ']', null);
    var areaId = (0, _get3.default)(areaValue, 'id', null);
    if (!(0, _has3.default)(acc, areaId)) {
      acc[areaId] = [];
    }
    acc[areaId].push({
      splitedKey: splitedKey,
      value: value,
      areaValueIndex: areaValueIndex
    });
  }, {});
};
exports.default = function (_ref, dimensionsWithValuesIndexedById, topoMap, display) {
  var observations = _ref.observations,
    dimensions = _ref.dimensions;
  var refAreaDimension = (0, _dotstatsuiteSdmxjs.getRefAreaDimension)({
    dimensions: dimensions
  });
  var observationsByAreas = parseByAreas(observations, refAreaDimension);
  var topology = (0, _get3.default)(topoMap, 'topology', {});
  var areaSelection = (0, _get3.default)(topoMap, 'areaSelection', null);
  var topoAreas = (0, _get3.default)(topology, 'objects.' + areaSelection, null);
  if (!observationsByAreas || !topoAreas) {
    return null;
  }
  var topoAreasWithData = (0, _map3.default)(topoAreas.geometries, function (areaGeometry) {
    var areaObservation = (0, _head3.default)((0, _get3.default)(observationsByAreas, (0, _get3.default)(areaGeometry, 'properties.id', null), []));
    var areaValueIndex = (0, _get3.default)(areaObservation, 'areaValueIndex', null);
    var areaValue = (0, _get3.default)(refAreaDimension, 'values[' + areaValueIndex + ']', null);
    return (0, _extends3.default)({}, areaGeometry, {
      properties: (0, _extends3.default)({}, (0, _get3.default)(areaGeometry, 'properties', {}), {
        label: (0, _dimensionUtils.dimensionValueDisplay)(display)(areaValue),
        value: (0, _head3.default)((0, _get3.default)(areaObservation, 'value', [])),
        category: (0, _dimensionUtils.categoryDisplay)((0, _get3.default)(areaObservation, 'splitedKey', null), dimensions, dimensionsWithValuesIndexedById, refAreaDimension.id, display)
      })
    });
  });
  return {
    objects: {
      areas: {
        type: topoAreas.type,
        geometries: topoAreasWithData
      }
    },
    arcs: topology.arcs,
    bbox: topology.bbox,
    transform: topology.transform
  };
};